import './scss/style.scss';
import 'bootstrap/dist/js/bootstrap.bundle.js';

import flatpickr from "flatpickr";
flatpickr.localize(flatpickr.l10ns['sr']);
flatpickr.localize(flatpickr.l10ns['mk']);
flatpickr.l10ns.default.firstDayOfWeek = 1;
import 'flatpickr/dist/l10n/sr.js';
import 'flatpickr/dist/l10n/mk.js';
require("flatpickr/dist/themes/airbnb.css");

import lozad from 'lozad';

import './js/globals';
import './js/analytics.js';

// lightgallery — only on pages with gallery elements
if (document.querySelector('[data-gallery-id]')) {
    import('lightgallery/src/js/lightgallery.js').then(() =>
        Promise.all([
            import('lightgallery/modules/lg-thumbnail.js'),
            import('lightgallery/modules/lg-fullscreen.js'),
            import('./js/components/gallery'),
        ])
    );
}

// details page
if (document.querySelector('#details-nav')) {
    import('./js/details');
    import('./js/inquiry');
}

// booking form (main booking page)
if (document.querySelector('.booking-form')) {
    import('./js/booking');
}

// booking add guests page
if (document.querySelector('.booking-add-guests')) {
    import('./js/bookingAddGuests.js');
}

// list pages

import('./js/list');


// contact page
if (document.querySelector('.form-contact')) {
    import('./js/contact');
}

window.observer = lozad('.lozad', {
    rootMargin: '200px 0px',
    loaded: el => {
        $(el).triggerHandler('lozadLoaded');
    }
});
window.observer.observe();

window.nobserver = lozad('.load-recaptcha', {
    rootMargin: '200px 0px',
    loaded: el => {
        $.getScript("https://www.google.com/recaptcha/api.js?render=" + '6LfJGFopAAAAACdVyXFKTpwJcDucy9CIiphMNilY');
    }
});
window.nobserver.observe();
